<template>
  <not-me-link :return-to-path="returnToPath" @click="trackClick">
    {{ linkText }}
  </not-me-link>
</template>

<script>
import { mapState } from 'vuex'
import NotMeLink from '@/campaign-action-shared/not-me-link'
import { trackEvent } from '@/analytics/track'

export default {
  components: { NotMeLink },

  props: {
    context: {
      type: String,
      required: true
    },

    userName: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState(['petition']),

    linkText() {
      return this.i18n.t(`petitions.signatures.${this.context}.click_here_if_not`, { member_name: this.userName })
    },

    returnToPath() {
      return `/petitions/${this.petition.slug}`
    }
  },

  methods: {
    trackClick() {
      trackEvent('User signed out from petition', {
        action: 'signed-out',
        category: 'petition',
        name: this.petition.slug,
        petition: this.petition.slug
      })
    }
  }
}
</script>
